import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import { useSettingsContext } from '../contexts/settings';
import { IPost } from '../types';

interface IProps {
	posts: Array<IPost>;
}

const NoResults = ({ posts }: IProps) => {
	const { clearFilters } = useFiltersContext();
	const { i18n } = useSettingsContext();

	if (!posts.length) {
		const handleOnClick = () => {
			if (clearFilters) {
				clearFilters();
			}
		};

		return (
			<div className="pfa-no-results">
				<h2 className="pfa-no-results__title">{i18n.noResultsTitle}</h2>
				<p className="pfa-no-results__description">{i18n.noResultsDesc}</p>
				<button className="btn-primary pfa-no-results__clear" onClick={handleOnClick}>
					{i18n.clearFilters}
				</button>
			</div>
		);
	}

	return <></>;
};

NoResults.displayName = 'NoResults';

export default NoResults;
